module.exports = __webpack_public_path__ + "static/img/max_pictgrid32_980x865.0965e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/max_pictgrid32_980x865.jpg
// module id = QDMW
// module chunks = 0